<template>
  <div>
    <h3 class="cards-title" v-html="translations.selectAmount"></h3>
    <div class="row">
      <div class="column large-4 medium-6 small-12" v-bind:key="t.id" v-for="t in types" @click="selectType(t)">
        <div class="small__package" style="background-image: url(/images/paket-bg-n.png);">
          <h2>{{ t.amount }}</h2>
          <div class="small__package-box">
            <p>{{ translations.validity}} {{ t.validDays }} {{ translations.days }}</p>
            <a class="button" :title="translations.topUp" :aria-label="translations.topUp">{{ translations.topUp }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../apiAccess.js'

export default {
  name: 'Finish',
  props: ['translations', 'types'],
  methods: {
    selectType(t) {
      this.$emit('startNumber', t)
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/SelectAmount.vue